export default "__VITE_ASSET__DHBTP_rv__"